import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { RebateDocumentView, SHMOKH_NAME } from './rebate-document-view';
import { useRebateDocumentData } from './use-rebate-document-data';

/**
 * Route-connected entry point: /rebate-invoice-print?bankId=<id>&commodityType=Local|International
 * Renders the "Marketing Incentive - invoice" letter: the bank pays Al Shmokh.
 */
export const RebateInvoicePrint = (props: RouteComponentProps) => {
  const { language, bankName, accountNumber, referenceNo, date, periodLabel, currency, amount } = useRebateDocumentData('invoice');

  return (
    <RebateDocumentView
      language={language}
      docType="invoice"
      referenceNo={referenceNo}
      date={date}
      recipientName={bankName}
      beneficiaryName={SHMOKH_NAME[language]}
      accountNumber={accountNumber}
      amount={amount}
      currency={currency}
      month={periodLabel}
    />
  );
};

export default RebateInvoicePrint;
